module.exports = __webpack_public_path__ + "img/activity.ec2ea5c1.svg";